import React, {useEffect, useState} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {StyleGuestAssignmentEditor} from "../../../shared/guests/GuestAssignmentEditor";
import {GuestsBrowserSimple} from "../../../shared/guests/GuestsBrowserSimple";
import {useApiNotification} from "../../../../ui/ApiNotificationProvider";
import {removeProGroupGuest} from "../../../../../api/pro-guest-functions";
import {ConfirmationPrompt} from "../../../../ui/ConfirmationPrompt";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {GreyedOutProgressMask} from "../../../../ui/GreyedOutProgressMask";
import {run} from "../../../../../utils/function-util";
import {GuestsActions} from "../../../shared/guests/GuestsActions";
import {Guest} from "../../../../../models/pro-guest.models";

const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(2),
            width: 300,
        },
    },
    actions: {
        '& > *': {
            marginRight: theme.spacing(2),
        },
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'space-between'
    }
}));

const GroupGuests = ({
    organizationId,
    folderId,
    groupId,
    onClose
}: any) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [userToDelete, setUserToDelete] = useState<any>();
    const [disableDelete, setDisableDelete] = useState(false);
    const {handleError} = useApiNotification();
    const [addMode, setAddMode] = useState(false);
    const [onlyPending, setOnlyPending] = useState(false);
    const [refresh, setRefresh] = useState(0);

    const removeGuest = async (user: any) => {
        setUserToDelete(user);
    };

    const deleteGuest = async () => {
        setDisableDelete(true);
    };

    useEffect(run(
        async () => {
            if (disableDelete) {
                               const userId = userToDelete.id;
                               setUserToDelete(null);
                return await removeProGroupGuest(organizationId, folderId, groupId, userId)
            }
        },
        () => {
            if (disableDelete)
                               setRefresh(r => r + 1);
        },
        handleError,
        () => setDisableDelete(false)
    ), [disableDelete]);

    const handleOnlyPendingUpdate = () => {
        const pending = !onlyPending;
        setOnlyPending(pending);
               setRefresh(r => r + 1);
    }

    const guestActions = (guest: Guest) => <GuestsActions organizationId={organizationId}
                                                 folderId={folderId}
                                                 groupId={groupId}
                                                 guest={guest}
                                                 onRemove={removeGuest}/>
    return addMode ?
               <Grid container spacing={3}>
                        <Grid item xs={12}>
                                <StyleGuestAssignmentEditor organizationId={organizationId}
                                       folderId={folderId}
                                       groupId={groupId}
                                       onDone={() => setAddMode(false)}
                                       onCancel={() => setAddMode(false)}
                />
            </Grid>
        </Grid>
        :
               <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.actionRow}>
                                <Typography variant="subtitle1">{t('ProGuest.Groups.Tabs.Guests.AlreadyIn')}</Typography>
                                <FormGroup row>
                                        <FormControlLabel
                                               control={<Switch checked={onlyPending} onChange={handleOnlyPendingUpdate} name="onlyPending" color="primary"/>}
                        labelPlacement="start"
                        label={t('ProGuest.Groups.Tabs.Guests.PendingOnly')}
                    />
                </FormGroup>
                                <Button variant="contained" color="primary" size="medium" onClick={() => setAddMode(true)}>
                    {t('ProGuest.Groups.AddGuest')}
                </Button>
            </Grid>
                        <Grid item xs={12}>
                                <GreyedOutProgressMask isActive={disableDelete} displaySpinner={true}>
                                        <GuestsBrowserSimple organizationId={organizationId}
                                         folderId={folderId}
                                         groupId={groupId}
                                         refresh={refresh}
                                         onlyPending={onlyPending}
                                         actionsRender={guestActions}
                    />
                                        <ConfirmationPrompt
                        title={t(`MyGuests.RemoveGuest.Title`)}
                        description={t('MyGuests.RemoveGuest.Description')}
                        warning={t('MyGuests.RemoveGuest.Warning')}
                        open={!!userToDelete}
                        disable={disableDelete}
                        onCancel={() => setUserToDelete(undefined)}
                        onConfirm={() => deleteGuest()}
                    />
                </GreyedOutProgressMask>
            </Grid>
                        <Grid xs={12} item={true} container justify="flex-end" direction="row" className={classes.actions}>
                                <Button variant="outlined" color="primary" size="medium"
                        onClick={onClose}>
                    {t('_Common.Labels.Close')}
                </Button>
            </Grid>
        </Grid>
}

export default GroupGuests;
